export default __webpack_public_path__ + "static/media/BLR13.e203b127.jpg";